import React from "react";
import moment from "moment";
import getStatus from "../../helpers/statuses";
import Label from "../Label/Label";
import {
  COMMUNICATION_ERROR,
  DEPLOYED,
  HALF_DEPLOYED,
  NOT_DEPLOYED,
} from "../../constants/statuses";
import StatusIndicator from "../StatusIndicator";
import HealthIndicator from "../HealthIndicator";
import BatteryBars from "../BatteryBars";
import SignalBars from "../SignalBars";
import {
  SENTINEL_TMA,
  SENTINEL_MOBILE_TRACKER,
  SENTINEL_TRACKER,
} from "../../constants/sentinel_types.js";
import styles from "./DeviceStatus.module.scss";
import Button from "../Button";
export default function DeviceStatus({
  status,
  signal,
  body,
  device_type,
  deployed,
  battery,
  batteryBars,
  firmware,
  temp,
  actionButton,
}) {
  return (
    <>
      {status && (
        <div className={styles.wrap}>
          <>
            <StatusIndicator status={status} />

            <div className={styles.text}>
              <h3 className={styles.status}>{getStatus(status).name}</h3>
            </div>
            {actionButton && (
              <div className={styles.action}>{actionButton}</div>
            )}
            {device_type === SENTINEL_MOBILE_TRACKER ||
              (device_type === SENTINEL_TMA && (
                <>
                  {status !== COMMUNICATION_ERROR ? (
                    <>
                      <StatusIndicator
                        status={
                          deployed === 0
                            ? DEPLOYED
                            : deployed === 4
                              ? HALF_DEPLOYED
                              : NOT_DEPLOYED
                        }
                      />
                    </>
                  ) : (
                    <>
                      <StatusIndicator status={COMMUNICATION_ERROR} />
                    </>
                  )}

                  <div className={styles.text}>
                    <h2 className={styles.status}>
                      {deployed === 0
                        ? "Deployed"
                        : deployed === 4
                          ? "Half Deployed"
                          : "Not deployed"}
                    </h2>
                  </div>
                </>
              ))}
          </>
        </div>
      )}
      <div>
        <div className={styles.meta}>
          <SignalBars signal={signal} />
          <BatteryBars
            battery={battery}
            bars={batteryBars}
          />
          {temp ? (
            <HealthIndicator
              title="Temperature"
              icon="whatshot"
              value={`${temp}°F`}
            />
          ) : null}
          {firmware ? (
            <HealthIndicator
              title="Firmware version"
              icon="sd_card"
              value={`v${firmware}`}
            />
          ) : null}
        </div>
      </div>
    </>
  );
}
